import { RefiPageHeader } from './page-header.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';
import '../../styles/reset.style.js';

defineRefiElement('refi-common-page-header', RefiPageHeader);
